import { Grid } from '@mantine/core';
import { TableBody } from 'components/Table/TableBody/TableBody';
import { queryKeys } from 'utils/query';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';
import { RuleItem } from 'models/rules';
import { PortalButton } from 'components/Button/PortalButton';
import { RuleDrawer } from 'components/Drawer/RuleDrawer/RuleDrawer';
import { useTranslation } from 'react-i18next';
import { useDrawerContext } from 'context/hooks';
import { RulesColumns } from 'components/Table/Columns/RulesColumns';
import { BsPlus } from 'react-icons/bs';
import { useParams } from 'react-router-dom';
import { getGroupRulesRecords } from 'hooks/api/rule/useGetRules';

export const GroupSettingsRules = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();
  const { groupId } = useParams<{ groupId: string }>();

  return (
    <Grid gutter={'lg'}>
      <Grid.Col span={12}>
        <TableBody<RuleItem>
          getData={getGroupRulesRecords}
          getColumns={() => RulesColumns({ showTypeColumn: false })}
          config={{ queryKey: `${queryKeys.groupRules}-${groupId}` }}
          titleBar={
            <PaperHeader titleKey={'group_monitoring_rules_title'}>
              <PortalButton
                size={'xs'}
                Icon={BsPlus}
                variant={'outline'}
                onClick={() =>
                  groupId &&
                  openDrawer({
                    content: <RuleDrawer createItem={{ groupId }} />,
                    size: '70%',
                    title: t('add_group_rule_label'),
                  })
                }
                label={t('add_group_rule_label')}
              />
            </PaperHeader>
          }
          emptyLabel={'no_rules_label'}
        />
      </Grid.Col>
    </Grid>
  );
};
